export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            'url(https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20golden%20film%20reel%20texture%20and%20flowing%20light%20trails%2C%20warm%20amber%20glow%20on%20deep%20charcoal%20black%20background%2C%20movie%20projector%20lens%20flare%20effect%2C%20luxurious%20cinema%20aesthetic%2C%20elegant%20film%20strip%20curves%2C%20professional%20movie%20industry%20visual%2C%20soft%20bokeh%20particles%2C%20dramatic%20atmospheric%20lighting&width=1600&height=900&seq=hero-bg-01&orientation=landscape)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/15 text-primary-400 text-xs font-medium mb-6 border border-primary-500/20 whitespace-nowrap">
              不缓冲秒开 · 高速加载
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 leading-tight mb-4">
              星空电影网
              <br />
              高清电影免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading font-semibold mb-6">
              告别等待，即点即播，畅享超清画质
            </p>

            <p className="text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              星空电影网专注为影迷打造极致观影体验。依托高速加载技术与智能预缓存引擎，实现真正的不缓冲秒开播放。
              平台每日更新海量高清片源，涵盖动作、喜剧、科幻、悬疑、爱情等全品类影视内容，
              无需注册即可免费在线观看。当前热门专题聚焦暑期档大片与经典修复重映，
              每周五晚定时上线最新资源，让每一次点击都直达精彩。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">99.7%</div>
                <div className="text-xs text-foreground-500 mt-1">秒开成功率</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading">12,000+</div>
                <div className="text-xs text-foreground-500 mt-1">高清片源覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-foreground-200 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">内容持续上新</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-lg transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                立即探索热播榜
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto px-8 py-3 bg-background-200/60 hover:bg-background-300/60 text-foreground-200 font-medium rounded-lg border border-background-300/40 transition-colors duration-200 text-sm whitespace-nowrap cursor-pointer text-center"
              >
                了解极速体验
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20composition%20with%20golden%20film%20reel%20and%20flowing%20light%20trails%2C%20warm%20amber%20glow%20on%20deep%20black%20background%2C%20movie%20projector%20lens%20flare%20effect%2C%20luxurious%20cinema%20aesthetic%2C%20elegant%20film%20strip%20curves%2C%20professional%20movie%20industry%20visual%2C%20soft%20bokeh%20particles%2C%20dramatic%20lighting&width=800&height=600&seq=hero-visual-01&orientation=landscape"
                alt="星空电影网 - 高清电影在线观看视觉主题"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) {
                    target.parentElement.style.display = 'none';
                  }
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}